module.exports = __webpack_public_path__ + "static/media/emot4_off.f3866da8.svg";